<template>
    <div class="app-container">
      <div class="flex">
        <div class="flex-left">
          <div class="tree-box">
            <BjDivider right-fixed>{{$t('billingPage.BillingCostItem')}}</BjDivider>
            <el-tree :data="treeData" node-key="id" :highlight-current="true" :expand-on-click-node="false" :default-expanded-keys="['1']" @node-click="handleNodeClick">
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <span>{{ node.label }}</span>
                <span>
                  <el-button icon="el-icon-plus" type="text" size="mini" @click="append(data)"></el-button>
                  <el-button :disabled="data.label == 'Category' || data.children.length>0" icon="el-icon-minus" type="text" size="mini" @click="remove(node, data)"></el-button>
                </span>
              </span>
            </el-tree>
          </div>
        </div>
        <div class="flex-right">
          <!-- :before-reset-search="reFreshLeftTree"  :before-query-search="beforeQuerySearch" -->
          <BjPage ref="BjPage" :get-action="queryApi" :query-params="queryParams" :col-span="colSpan" :serial="serial" :search-btn-hide="true" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu">
            <template v-slot:tableColumn>
              <template v-for="(col, index) in dropCols">
                <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :min-width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item">
                  <template slot-scope="scope">
                    <template v-if="false" />
                    <!-- <span v-else-if="col.prop === 'supervisor'">
                      <span>{{ scope.row.supervisorJSTrans }}</span>
                    </span> -->
                    <span v-else>{{ scope.row[col.prop] | timezoneFilters(scope.row[col.prop]) }}</span>
                  </template>
                </el-table-column>
                <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :min-width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
                  <template slot-scope="scope">
                    <el-button type="text" class="edit-btn" @click="onEdit(scope.row)">{{ $t('editText') }}</el-button>
                    <el-button type="text" class="delete-btn" @click="onDel(scope.row)">{{ $t('delText') }}</el-button>
                  </template>
                </el-table-column>
              </template>
            </template>
          </BjPage>
        </div>
      </div>
      <!-- 新增编辑弹窗 -->
      <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" width="450px" :before-close="handleClose" :close-on-click-modal="false" :close-on-press-escape="false">
        <el-form ref="form" :model="form" label-position="top" :rules="rules">
          <el-col>
            <el-form-item :label="$t('billingPage.expenseItem')" prop="item">
              <BjInput v-model="form.item" :placeholder="$t('billingPage.expenseItem')"/>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item :label="$t('billingPage.expenseCategory')" prop="category">
              <el-cascader style="width:100%" ref="cascader4" v-model="form.category" :options="CategoryList" @change="costCategoryFormChange" :placeholder="$t('billingPage.expenseCategory')" filterable clearable :show-all-levels="false" :props="{ expandTrigger: 'hover' }"></el-cascader>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item :label="$t('billingPage.description')" prop="description">
              <BjInput v-model="form.description" :placeholder="$t('billingPage.description')"/>
            </el-form-item>
          </el-col>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="handleClose">{{ $t('cancelText') }}</el-button>
          <el-button type="primary" @click="onSave()">{{ $t('okText') }}</el-button>
        </div>
      </el-dialog>
    </div>
  </template>
  <script>
  let id = 1000;
  import pageMiXin from '@/utils/page-mixin.js';
  import { funConfigApi } from '@/api';
  const getDefaultForm = () => {
    return {
      openType: null,
      id: null,
      item: null,
      category: null,   // 参数：字符串化数组ID "[\"2\",\"5001\"]"
      categoryArrays: null, // 参数：label名称 "Ocean Freight"
      description: null,
    };
  };
  
  export default {
    name: 'BusinessBillingCostItem',
    components: {},
    mixins: [pageMiXin],
    data() {
      return {
        queryApi: funConfigApi.getBillingCostItemList,
        queryParams: {
          id: null,
        },
        labelList: [
          { label: this.$t('billingPage.expenseItem'), prop: 'item', isCheck: true, disabled: false, },
          { label: this.$t('billingPage.expenseCategory'), prop: 'categoryArrays', isCheck: true, disabled: false, },
          { label: this.$t('billingPage.description'), prop: 'description', isCheck: true, disabled: false, },
          { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, },
        ],
        // 树形控件 mock数据
        treeData:[],
        // 弹窗相关数据
        dialogTitle:null,
        dialogFormVisible: false,
        costCategoryForm:null,
        CategoryList: [],
        form: getDefaultForm(),
        rules: {
          item: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
          category: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        },
      };
    },
    computed: {},
    mounted(){
      this.getCostExpendit();
      // 获取树形控件数据
      this.getTreeData('init')
    },
    methods: {
      // 获取支出类别下拉数据
      getCostExpendit() {
        funConfigApi.getCostExpenditureCategoryPull().then(res => {
          this.CategoryList = res
        });
      },
      costCategoryFormChange(){
        setTimeout(() => {
          this.form.categoryArrays = this.$refs.cascader4.getCheckedNodes()[0]?.label
        }, 300);
      },
      // 获取树形控件数据
      getTreeData(init){
        funConfigApi.getBillingCostItemTree().then(res=>{
          if(res.length>0){
            this.treeData = res
            if(init){
              this.queryParams.id = this.treeData[0].id
            }
            this.reFresh()
          }else{
            this.treeData = []
          }
        })
      },
      // 点击树形控件名称触发：刷新并重新获取右侧列表数据
      handleNodeClick(data) {
        this.queryParams.id = data.id
        this.reFresh();
      },
      // 树形控件(+)新增
      append(data) {
        this.form.openType = 'append'
        this.dialogTitle = this.$t('addText')
        this.form.id = data.id
        this.dialogFormVisible = true;
      },
      // 列表编辑
      onEdit(row) {
        this.form = JSON.parse(JSON.stringify(row));
        this.form.openType = 'edit'
        this.form.category = JSON.parse(this.form.category)
        this.dialogTitle = this.$t('editText')
        this.dialogFormVisible = true;
      },
      // 树形控件(-)移除
      remove(node, data) {
        this.$confirm(this.$t('toast.deletionConfirmationText'), this.$t('toast.hintText'), {
          confirmButtonText: this.$t('toast.okText'),
          cancelButtonText: this.$t('toast.cancelText'),
          type: 'warning',
        })
          .then(() => {
            funConfigApi.delBillingCostItemList({id: data.id}).then(res => {
              if(!res.failed){
                this.msgSuccess(this.$t('toast.operationSuccessText'));
                // 刷新树形控件数据
                this.getTreeData()
                // 刷新列表数据
                this.reFresh();
              }
            });
          })
          .catch(() => { });
      },
      // 列表删除
      onDel(row) {
        this.$confirm(this.$t('toast.deletionConfirmationText'), this.$t('toast.hintText'), {
          confirmButtonText: this.$t('toast.okText'),
          cancelButtonText: this.$t('toast.cancelText'),
          type: 'warning',
        })
          .then(() => {
            funConfigApi.delBillingCostItemList({id: row.id}).then(res => {
              if(!res.failed){
                this.msgSuccess(this.$t('toast.operationSuccessText'));
                // 刷新树形控件数据
                this.getTreeData()
                // 刷新列表数据
                this.reFresh();
              }
            });
          })
          .catch(() => { });
      },
      // 保存弹窗数据 并 关闭编辑弹窗
      onSave() {
        this.$refs.form.validate(valid => {
          if (valid) {
            if(this.form.openType == 'append'){
              const POST_DATA = {
                id : this.form.id,
                item : this.form.item,
                category : JSON.stringify(this.form.category),
                categoryArrays : this.form.categoryArrays,
                description : this.form.description,
              }
              funConfigApi.addBillingCostItemList(POST_DATA).then(res => {
                if(!res.failed){
                  this.msgSuccess(this.$t('toast.operationSuccessText'));
                  // 清空弹框数据
                  this.handleClose()
                  // 刷新树形控件数据
                  this.getTreeData()
                  // 刷新列表数据
                  this.reFresh();
                }
              });
            }else if(this.form.openType == 'edit'){
              const POST_DATA = {
                id : this.form.id,
                item : this.form.item,
                category : JSON.stringify(this.form.category),
                categoryArrays : this.form.categoryArrays,
                description : this.form.description,
              }
              funConfigApi.editBillingCostItemList(POST_DATA).then(res => {
                if(!res.failed){
                  this.msgSuccess(this.$t('toast.operationSuccessText'));
                  // 清空弹框数据
                  this.handleClose()
                  // 刷新树形控件数据
                  this.getTreeData()
                  // 刷新列表数据
                  this.reFresh();
                }
              });
            }
          }
        })
      },
      /** 关闭弹窗 清空数据 */
      handleClose() {
        this.form = getDefaultForm();
        // this.costCategoryForm = null;
        this.$refs.form.resetFields();
        this.dialogFormVisible = false;
      },
    },
  };
  </script>
  <style lang="scss" scoped>
  .el-tag + .el-tag {
    margin-left: 10px;
  }
  .flex {
    flex-wrap: nowrap;
    .flex-left {
      width: 333px;
      height: 100%;
      overflow: auto;
    }
    .flex-right {
      width: calc(100% - 333px);
    }
  }
  .tree-box {
    overflow: auto;
    min-height: 100%;
    height: calc(100vh - 265px);
    margin-right: 30px;
  }
  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
  }
  ::v-deep .bj-page .el-form-item__label{
    display: none;
  }
  </style>
  